function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M166.43,8.071L0,174.501l130.814,130.814l164.403-164.402l2.009-2.01l8.466-138.526L166.43,8.071z M282.602,132.315 L130.814,284.103L21.213,174.501l151.77-151.77l116.71-6.448L282.602,132.315z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235.467,99.849c8.013,0,15.547-3.12,21.214-8.787c11.695-11.696,11.695-30.729-0.001-42.427 c-5.666-5.666-13.2-8.786-21.213-8.786s-15.547,3.12-21.214,8.786c-5.666,5.667-8.787,13.2-8.787,21.214s3.121,15.547,8.788,21.214 C219.92,96.729,227.454,99.849,235.467,99.849z M224.859,59.242c2.834-2.833,6.601-4.394,10.607-4.394s7.773,1.561,10.606,4.393 c5.849,5.849,5.849,15.366,0.001,21.214c-2.834,2.833-6.601,4.394-10.607,4.394s-7.773-1.561-10.606-4.394 c-2.834-2.833-4.395-6.6-4.395-10.606S222.026,62.075,224.859,59.242z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgPricing = function SvgPricing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 305.692 305.692",
    style: {
      enableBackground: "new 0 0 305.692 305.692"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPricing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pricing.570766d0.svg";
export { ForwardRef as ReactComponent };